import { RemoteShellNirvanaDataProvider } from '../dataProvider/RemoteShellNirvanaDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_NIRVANA } from '../../../webcomponents.constants';

export class RemoteShellDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_NIRVANA, RemoteShellNirvanaDataProvider);
  }
}
